export interface CustomerProfile {
    id: string;
    userId: string;
    type: CustomerType;
    email: string;
    name: string;
    postalCode: string;
    roles: string[];
    companyName?: string;
    vatNumber?: string;
    address?: string;
    phoneNumber?: string;
    certifications?: CertificationType[];
    profileImage?: string;
    rating?: number;
    createdAt?: Date;
    updatedAt?: Date;
}

export enum CustomerType {
    USER = 'USER',
    COMPANY = 'COMPANY'
}


export interface CustomerProfileCertification {
    certificationType: CertificationType;
    certificationCode: string;
    status: CertificationStatus;
    expirationDate?: string,
}

export enum CertificationStatus {
    NEW = 'NEW',
    PENDING = 'PENDING',
    VERIFIED = 'VERIFIED',
    REJECTED = 'REJECTED',
}



export enum CertificationType {
    ISO9001 = 'ISO9001',
    ISO14001 = 'ISO14001',
    ANREPA = 'ANREPA',
    EPAL = 'EPAL',
    NIMA = 'Código NIMA',
}

export interface PublicCustomerProfile {
    name: string;
    postalCode: string;
    companyName?: string;
    rating?: number;
    certifications: CertificationType[];
}